module.exports = __webpack_public_path__ + "img/fi-organic-breakfast-800x527.85269418.jpg";